import React, { Component } from 'react';
import Loader from 'react-loader-spinner'
import CreateUser from './CreateUser';
import AdminDashboard from './AdminDashboard';
import ApprovePromos from './ApprovePromos';
import { signOut } from '../../firebase'
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import Notification from './Notification';
import Promos from './Promos';
import Partners from './Partners';
import MappedEvents from './MappedEvents';
import Calendar from './Calendar';
import Directory from './directory.screen';
import { observer } from 'mobx-react';

const FunAdmin = observer( class FunAdmin extends Component {
	constructor(){
	    super()

	    this.state = {
	      createUser: false,
	      stats: true,
        approve: false,
        notification: false,
        promos: false,
        partners: false,
        map: false,
        calendar: false,
				directory: false
	    }

	    this.togglePage = this.togglePage.bind(this)
	}

	componentDidMount(){
		this.setState({...this.props})
	}

	togglePage(view){

    switch(view){

      case 'business':
        this.setState({approve: false,createUser:true,stats:false,notification: false, promos: false, partners: false, map: false, calendar: false, directory: false})
      break;

      case 'stats':
        this.setState({approve: false,createUser:false,stats:true,notification: false, promos: false, partners: false, map: false, calendar: false, directory: false})
      break;

      case 'approve':
        this.setState({approve: true,createUser:false,stats:false,notification: false, promos: false, partners: false, map: false, calendar: false, directory: false})
      break;

      case 'notification':
        this.setState({approve: false,createUser:false,stats:false,notification: true, promos: false, partners: false, map: false, calendar: false, directory: false})
      break;

      case 'promos':
        this.setState({approve: false,createUser:false,stats:false,notification: false, promos: true, partners: false, map: false, calendar: false, directory: false})
      break;

      case 'partners':
        this.setState({approve: false,createUser:false,stats:false,notification: false, promos: false, partners:true, map: false, calendar: false, directory: false})
      break;

      case 'map':
        this.setState({approve: false,createUser:false,stats:false,notification: false, promos: false, partners:false, map: true, calendar: false, directory: false})
      break;

      case 'calendar':
        this.setState({approve: false,createUser:false,stats:false,notification: false, promos: false, partners:false, map: false, calendar: true, directory: false})
      break;

			case 'directory':
        this.setState({approve: false,createUser:false,stats:false,notification: false, promos: false, partners:false, map: false, calendar: false, directory: true})
      break;

      }

  }

  render() {
		let { myStores } = this.props;
		let { mainStore } = myStores;
    return (
      <div>
      <div style={{fontSize: 20, width: '100%'}}>
      <AppBar style={{marginTop: "10vh"}} width="inherit">
          <Toolbar>
               <Typography variant='title'
                           color='inherit'
                           style={{
                            fontSize: 15,
                            marginLeft:20
                           }}
                           onClick={()=> this.togglePage('business')}
                           role='button'
               >Add Business
               </Typography>

               <Typography variant='title'
                           color='inherit'
                           style={{
                            fontSize: 15,
                            marginLeft:20
                           }}
                           onClick={()=> this.togglePage('stats')}
                           role='button'
               >Stats
               </Typography>

               <Typography variant='title'
                           color='inherit'
                           style={{
                            fontSize: 15,
                            marginLeft:20,
                            textDecoration: 'none'
                           }}
                           onClick={()=> this.togglePage('approve')}
                           role='button'
               >Approve Events
               </Typography>

               <Typography variant='title'
                           color='inherit'
                           style={{
                            fontSize: 15,
                            marginLeft:20
                           }}
                           onClick={()=> this.togglePage('notification')}
                           role='button'
               >Notification
               </Typography>

               <Typography variant='title'
                           color='inherit'
                           style={{
                            fontSize: 15,
                            marginLeft:20
                           }}
                           onClick={()=> this.togglePage('promos')}
                           role='button'
               >Promo Codes
               </Typography>

               <Typography variant='title'
                           color='inherit'
                           style={{
                            fontSize: 15,
                            marginLeft:20
                           }}
                           onClick={()=> this.togglePage('partners')}
                           role='button'
               >Partners
               </Typography>

               <Typography variant='title'
                           color='inherit'
                           style={{
                            fontSize: 15,
                            marginLeft:20
                           }}
                           onClick={()=> this.togglePage('map')}
                           role='button'
               >Map
               </Typography>

               <Typography variant='title'
                           color='inherit'
                           style={{
                            fontSize: 15,
                            marginLeft:20
                           }}
                           onClick={()=> this.togglePage('calendar')}
                           role='button'
               >Calendar
               </Typography>

							 <Typography variant='title'
                           color='inherit'
                           style={{
                            fontSize: 15,
                            marginLeft:20
                           }}
                           onClick={()=> this.togglePage('directory')}
                           role='button'
               >Directory
               </Typography>

							 <Typography variant='title'
                           color='inherit'
                           style={{
                            fontSize: 15,
                            marginLeft:20
                           }}
                           onClick={()=> mainStore.signOut()}
                           role='button'
               >Logout
               </Typography>

            </Toolbar>
        </AppBar>
        </div>
        {
          this.state.createUser
            ? <CreateUser { ...this.props } />
            : null
        }
        {
          this.state.stats
            ? <AdminDashboard {...this.props} />
            : null
        }
        {
          this.state.approve
            ? <ApprovePromos { ...this.props } />
            : null
        }
        {
          this.state.notification
            ? <Notification />
            : null
        }
        {
          this.state.promos
            ? <Promos { ...this.props } />
            : null
        }

        {
          this.state.partners
            ? <Partners { ...this.props } />
            : null
        }
        {
          this.state.map
            ? <MappedEvents { ...this.props } />
            : null
        }

        {
          this.state.calendar
            ? <Calendar { ...this.props } />
            : null
        }

				{
					this.state.directory ?
						<Directory { ...this.props } />
					: null
				}

      </div>
    )

  }
})
/*
<a href="https://goo.gl/3t3TDy" target="_blank" style={{textDecoration: 'none', color: 'inherit'}}>
*/

export default FunAdmin



// WEBPACK FOOTER //
// ./src/components/admin/FunAdmin.js